import { SemboDate } from '@libs/sembo-dates';
import type { MonthIndex } from '@libs/sembo-dates';

export function getStartSearchDateFromPreferredDay(preferredDay: Date): Date {
  const startOfPreferredDayMonth = new SemboDate(preferredDay)
    .startOf('month')
    .get();

  const todayDate = new SemboDate().startOf('day').get();

  if (new SemboDate(startOfPreferredDayMonth).isBefore(todayDate)) {
    return todayDate;
  }

  return startOfPreferredDayMonth;
}

export function getStartSearchDateWithoutPreferredDay(
  preferredMonth: MonthIndex | undefined
): Date | undefined {
  if (preferredMonth !== undefined) {
    const preferredMonthDate = new Date();
    preferredMonthDate.setMonth(preferredMonth, 1);

    if (
      new SemboDate(preferredMonthDate).isBefore(new Date()) &&
      new Date().getMonth() === preferredMonth
    ) {
      preferredMonthDate.setDate(new Date().getDate());
    }

    const preferredMonthSemboDate = new SemboDate(preferredMonthDate);

    if (preferredMonthSemboDate.endOf('month').isBefore(new Date())) {
      preferredMonthSemboDate.add({ years: 1 });
    }
    return preferredMonthSemboDate.get();
  }
}

export function getEndSearchDateFromPreferredDay(preferredDay: Date): Date {
  return new SemboDate(preferredDay).endOf('month').get();
}

export function getEndSearchDateWithoutPreferredDay(
  preferredMonth: MonthIndex | undefined
): Date | undefined {
  const startDate = getStartSearchDateWithoutPreferredDay(preferredMonth);

  if (startDate) {
    const searchingMonthStartDate = new SemboDate(startDate);

    return searchingMonthStartDate.endOf('month').get();
  }
}
